import * as React from 'react'
import clsx from 'clsx'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { Trustpilot } from '../../_shared/Trustpilot'
import { VALUE_CARDS, type ValueCardIcon, type ValueCardVariant } from '../content'
import { OwlSlideshow } from '../components/OwlSlideshow'
import { Mission } from './Mission'
import styles from './Makers.module.css'

const VARIANT_CLASS: Record<ValueCardVariant, string> = {
  yellow: styles.valueYellow,
  blue: styles.valueBlue,
  pink: styles.valuePink,
  mint: styles.valueMint,
}

function ValueIcon({ icon }: { icon: ValueCardIcon }): React.ReactElement {
  switch (icon) {
    case 'bulb':
      return <plume.glyphs.stroke.Bulb size={24} />
    case 'people':
      return <plume.glyphs.stroke.People size={24} />
    case 'megaphone':
      return <plume.glyphs.stroke.Megaphone size={24} />
    case 'star':
      return <plume.glyphs.stroke.Star size={24} />
  }
}

export function Makers(): React.ReactElement {
  return (
    <section className={styles.makers} id="makers">
      <Container className={styles.makers__stack}>
        <div className={styles.makers__head}>
          <div className={styles.makers__intro}>
            <h2 className={styles.makers__title}>
              Au service des <em>makers</em> 💪
            </h2>
            <p className={styles.makers__lede}>
              Ulule accompagne des milliers de projets créatifs, solidaires et innovants. Derrière chaque
              collecte réussie, il y a une équipe qui y croit : techno &amp; produit, expertise, conseils,
              partenariats, nous voulons proposer la meilleure plateforme pour lancer ou développer vos
              projets&nbsp;!
            </p>
          </div>
          <div className={styles.makers__portrait}>
            <OwlSlideshow />
          </div>
        </div>

        <div className={styles.values}>
          {VALUE_CARDS.map((card) => (
            <article
              key={card.title}
              className={clsx(styles.value, VARIANT_CLASS[card.variant])}
              style={{ '--rot': `${card.rotate}deg` } as React.CSSProperties}
            >
              <span className={styles.value__icon}>
                <ValueIcon icon={card.icon} />
              </span>
              <h3 className={styles.value__title}>{card.title}</h3>
              <p className={styles.value__body}>{card.body}</p>
            </article>
          ))}
        </div>

        <Trustpilot className={styles.trust} />

        <Mission />
      </Container>
    </section>
  )
}
